import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  thirdPDOModalTitle: {
    description: 'Third Party Delivery Options Modal Title',
    defaultMessage: 'Delivery Options',
    id: 'we0aYC',
  },
  overview: {
    description: 'Third Party Delivery Options Overview Header',
    defaultMessage: 'Overview',
    id: 'NmSERM',
  },
  customerSelectedShipping: {
    description: 'Third Party Delivery Options Customer Selected Shipping label',
    defaultMessage: 'Customer Selected Shipping',
    id: 'rBvGz0',
  },
  orderNumberLabel: {
    description: 'Third Party Delivery Options Overview > Order Label',
    defaultMessage: 'Order',
    id: 'QWnOUc',
  },
  insuredValueLabel: {
    description: 'Third Party Delivery Options Overview > Insured Value Label',
    defaultMessage: 'Insured Value',
    id: 'sZM9/s',
  },
  totalShippingPriceLabel: {
    description: 'Third Party Delivery Options Overview > Total Shipping Price Label',
    defaultMessage: 'Total Shipping Price',
    id: 'lG4im3',
  },
  estimatedDeliveryLabel: {
    description: 'Third Party Delivery Options Overview > Estimated Delivery Label',
    defaultMessage: 'Estimated Delivery',
    id: '914ozW',
  },
  carrierTitleLabel: {
    description: 'Third Party Delivery Options Overview > Carrier Label',
    defaultMessage: 'Carrier',
    id: '9fLASD',
  },
  weight: {
    description: 'Third Party Delivery Options Overview > Weight Label',
    defaultMessage: 'Weight',
    id: '3DSvQZ',
  },
  dimensions: {
    description: 'Third Party Delivery Options Overview > Dimensions Label',
    defaultMessage: 'Dimensions',
    id: 'RkU7X3',
  },
  packageCode: {
    description: 'Third Party Delivery Options Overview > Package Code Label',
    defaultMessage: 'Package Code',
    id: 'zlLWt0',
  },
  methodLabel: {
    description: 'Third Party Delivery Options Overview > Method Label',
    defaultMessage: 'Method',
    id: 'UtptaC',
  },
  descriptionLabel: {
    description: 'Third Party Delivery Options Overview > Description Label',
    defaultMessage: 'Description',
    id: 'ib0kDD',
  },
  shippingFromHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Shipping From Header Label',
    defaultMessage: 'Shipping From: {shipmentDetailName}',
    id: 'jTKIgm',
  },
  shipmentDetailsHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Header Label',
    defaultMessage: 'Shipment Details',
    id: 'oA7ni2',
  },
  shipmentInfoHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Shipment Info Header Label',
    defaultMessage: 'Shipment Info',
    id: '9adhDA',
  },
  dateAndTimeHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Date and Time Header Label',
    defaultMessage: 'Date & Time',
    id: '7ah9c+',
  },
  shipToHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Shipping To Header Label',
    defaultMessage: 'Shipping To',
    id: 'qh3Rv9',
  },
  shippingServiceLabel: {
    description: 'Third Party Delivery Options Shipment Details, Shipping Service Label',
    defaultMessage: 'Shipping Service',
    id: 'kU0N8B',
  },
  shippingFeeHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Shipping Fee Header Label',
    defaultMessage: 'Shipping Fee',
    id: 'WdEuwq',
  },
  methodHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Method Header Label',
    defaultMessage: 'Method',
    id: 'sphSFK',
  },
  deliveryDateHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Delivery Date Header Label',
    defaultMessage: 'Delivery Date',
    id: 'd20pZD',
  },
  handlingFeeHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Handling Fee Header Label',
    defaultMessage: 'Handling Fee',
    id: 'tlH4OX',
  },
  totalChargesHeaderLabel: {
    description: 'Third Party Delivery Options Shipment Details, Total Charges Header Label',
    defaultMessage: 'Total Charges',
    id: 'FmF7Mp',
  },
  packageDetailsHeader: {
    description: 'Third Party Delivery Options Package Details, Header',
    defaultMessage: 'Package Details',
    id: '32g+59',
  },
  itemsHeader: {
    description: 'Third Party Delivery Options Package Details, Items Header',
    defaultMessage: 'Items',
    id: '3JIYkG',
  },
});
